import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, Divider } from "@material-ui/core";
import CustomSwitchWithTitle from "../../../../../components/SwitchWidthTitle/CustomSwitchWithTitle";
import {
  ACCESS,
  CONFIGURE_WEBHOOK,
  WEBHOOK_EVENT_INFO_LABELS,
  WEBHOOK_NOTIFICATION_INFO_LABELS,
  WEBHOOK_TYPES,
} from "../../../../../constants/strings";

const isAllGroupKey = (key) => key?.toString().toUpperCase() === "ALL";

const isItemEnabled = (item) =>
  item.webhookEnabled != null
    ? item.webhookEnabled
    : item.webhookIsEnabled ?? false;

const WebhookToggles = ({
  label,
  webhookType,
  toggles,
  handleWebhookToggle,
}) => {
  const isEventType = webhookType === WEBHOOK_TYPES.EVENT;

  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">{`${label.slice(
          0,
          -1
        )} ${ACCESS}`}</Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {`${CONFIGURE_WEBHOOK} ${label}`}
        </Typography>
      </Grid>

      {Object.entries(toggles).map(([category, items]) => {
        const isAllEnabledInCategory =
          isEventType &&
          (items || []).some(
            (item) =>
              isAllGroupKey(item.code || item.group) && isItemEnabled(item)
          );
        return (
          <Grid item xs={12} key={category}>
            <Typography variant="subtitle1" gutterBottom>
              {category}
            </Typography>
            {items &&
              items.map((item, index) => {
                const itemKey = item.code || item.group;
                const itemLabel = item.name || item.description;
                const eventCategoryInfoLabels =
                  WEBHOOK_EVENT_INFO_LABELS?.[category];
                const itemInfoLabel = isEventType
                  ? eventCategoryInfoLabels?.[itemKey]
                  : WEBHOOK_NOTIFICATION_INFO_LABELS?.[category]?.[itemKey] ||
                    WEBHOOK_NOTIFICATION_INFO_LABELS?.DEFAULT;
                const isAllItem = isAllGroupKey(itemKey);
                const disabledBecauseAllEnabled =
                  isAllEnabledInCategory && !isAllItem;
                const disabledBecauseNotEditable =
                  !isEventType && item.isEditable === false;
                return (
                  <Grid item xs={12} key={`${category}-${itemKey || index}`}>
                    <CustomSwitchWithTitle
                      input={{
                        checked:
                          isAllEnabledInCategory && !isAllItem
                            ? false
                            : isItemEnabled(item),
                        onChange: (event) =>
                          handleWebhookToggle(
                            category,
                            itemKey,
                            event.target.checked
                          ),
                      }}
                      label={itemLabel}
                      infoLabel={itemInfoLabel || null}
                      disabled={
                        disabledBecauseNotEditable || disabledBecauseAllEnabled
                      }
                    />
                  </Grid>
                );
              })}
          </Grid>
        );
      })}
    </>
  );
};

WebhookToggles.propTypes = {
  label: PropTypes.string.isRequired,
  webhookType: PropTypes.string.isRequired,
  toggles: PropTypes.object.isRequired,
  handleWebhookToggle: PropTypes.func,
};

export default WebhookToggles;
